import React from 'react';
import { Link } from 'react-router-dom';
import { trustedLogos } from '../../mock/content';
import { upsideStats } from '../../mock/content';
import CountUp from './CountUp';
import { track, events } from '../../lib/analytics';

const Hero = () => {
  return (
    <section id="top" className="relative">
      {/* Dark hero */}
      <div className="relative min-h-[92vh] flex items-center overflow-hidden bg-navy-deep">
        {/* Background video */}
        <video
          className="absolute inset-0 w-full h-full object-cover"
          src="https://videos.pexels.com/video-files/3129957/3129957-uhd_2560_1440_25fps.mp4"
          poster="https://images.unsplash.com/photo-1513563326940-e76e4641069e?w=1920&q=80"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
        />
        {/* Dark navy overlay for legibility */}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              'linear-gradient(180deg, rgba(20,30,52,0.75) 0%, rgba(20,30,52,0.88) 100%)',
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-br from-navy-deep/40 via-navy-deep/10 to-brand-blue/15 pointer-events-none" />
        <div className="relative max-w-6xl mx-auto w-full px-6 lg:px-8 pt-32 pb-40">
          <p className="text-brand-blue-light text-[12px] font-bold tracking-[0.14em] uppercase mb-5">
            The revenue engine behind ambitious B2B media brands
          </p>
          <h1 className="text-white font-black tracking-[-0.01em] leading-[1.05] text-[44px] sm:text-[58px] md:text-[72px] max-w-[900px]">
            The old publishing model is running out of road.
          </h1>
          <p className="mt-7 text-slate-200/85 text-[16px] md:text-[17px] leading-[1.65] max-w-[560px]">
            Launch a profitable lead generation business under your brand. We run everything behind the scenes. Every lead verified before your client ever sees it.
          </p>
          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <Link
              to="/contact"
              data-testid="hero-grab-15-btn"
              onClick={() => track(events.GRAB_15_CALL_CLICK, { location: 'hero' })}
              className="inline-flex items-center justify-center h-11 px-7 rounded-md bg-brand-pink hover:bg-brand-pink/90 text-white text-[13px] font-bold uppercase tracking-[0.08em] shadow-mk hover:shadow-mk-lg hover:-translate-y-0.5 transition-all duration-300"
            >
              Grab a 15-minute call
            </Link>
            <a
              href="#playbook"
              className="inline-flex items-center justify-center h-11 px-7 rounded-md bg-white/[0.06] backdrop-blur border border-white/25 text-white text-[13px] font-bold uppercase tracking-[0.08em] hover:bg-white/[0.12] transition-all duration-300"
            >
              Download the 2026 Playbook
            </a>
          </div>
          <p className="mt-6 text-slate-300/80 text-[13.5px] max-w-[480px] leading-[1.6]">
            15 minutes with a publishing revenue expert. No deck, no pitch — just where your next revenue line is.
          </p>
        </div>
      </div>

      {/* Floating stats + logos card */}
      <div className="relative -mt-24 pb-16">
        <div className="max-w-6xl mx-auto px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-mk-lg px-6 sm:px-10 py-10 sm:py-12">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-6">
              {upsideStats.map((s) => (
                <div key={s.label} className="text-center md:text-left">
                  <div className="text-brand-blue text-[36px] sm:text-[42px] font-black leading-none tracking-tight">
                    <CountUp value={s.value} />
                  </div>
                  <p className="mt-3 text-body-muted text-[13.5px] leading-[1.5] font-medium">
                    {s.label}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-10 pt-8 border-t border-slate-100">
              <p className="text-body-muted text-[11.5px] font-bold tracking-[0.16em] uppercase text-center mb-5">
                Trusted by B2B publishers, agencies and demand providers worldwide
              </p>
              <div className="grid grid-cols-3 md:grid-cols-6 gap-6 items-center">
                {trustedLogos.map((l) => (
                  <div
                    key={l.name}
                    className="text-center text-slate-500 font-bold text-[13px] tracking-tight opacity-70 hover:opacity-100 transition-opacity"
                  >
                    {l.name}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
